import React from 'react';

const AuthToggle = ({ isLogin, onToggle, allowRegister = true }) => {
  return (
    <div className={`flex items-center justify-center gap-2 p-1 bg-muted rounded-lg ${!allowRegister ? 'opacity-50 pointer-events-none' : ''}`}>
      <button
        onClick={() => onToggle(true)}
        className={`flex-1 px-6 py-2.5 rounded-md text-sm font-medium transition-all duration-200 ${
          isLogin
            ? 'bg-background text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        Sign In
      </button>
      {allowRegister && (
        <button
          onClick={() => onToggle(false)}
          className={`flex-1 px-6 py-2.5 rounded-md text-sm font-medium transition-all duration-200 ${
            !isLogin
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          Register
        </button>
      )}
    </div>
  );
};

export default AuthToggle;